import React from 'react';

import { EVENTS } from '../../utilities/CONSTANTS';
import { getCreateDraftUrlWithQuestionId } from '../../utilities/urlHelper';

const AnswerQuestionDropDown = (props) => {
    const handleOnMouseDown = (e) => {
        window.dispatchEvent(new Event(EVENTS.SHOW_CHOOSE_PAGE_DIALOG));
    };
    return (
        <div className="left">
            <button className="dropdown-link btn-secondary mr1 mt2 fuchsia">
                Attach...
                <span className="dropdown-carat" />
            </button>
            <div className="dropdown-overlay" style={{ display: 'none' }} />
            <div className="dropdown-content" style={{ display: 'none' }}>
                <span className="dropdown-option link" onClick={handleOnMouseDown}>Page or link</span>
                <a className="dropdown-option" href={getCreateDraftUrlWithQuestionId(props.questionId)}>New page</a>
            </div>
        </div>
    );
};

export default AnswerQuestionDropDown;
